<template>
   <div data-testid="threshold-page" class="all-height all-width">
    <div class="pa-6 d-flex flex-column gap-6 pb-16">
          <div class="d-flex flex-column gap-6">
            <MaterialityHeader 
              :count="formatedData.length" 
              :headers="headers"
              :visibleColumns="visibleColumns"
              @open-faq="faqdialog = true" 
              @refresh="refreshData"
              @pending-approval-list="openPendingApprovalDialog"
              @columns-change="handleColumnsChange"
            />
            <div class="d-flex flex-column gap-3">
              <MaterialityCountCard  :MaterialityCountCard="meta.totalCount" :loading="loading" :hierarchyLoading="hierarchyLoading" @materiality-file-upload="openBulkUploadDialog()" />

            <!-- Materiality Table Component -->
            <MaterialityTable
              ref="materialityTable"
              data-testid="threshold-page__materiality-table"
              :headers="filteredHeaders"
              :items="formatedData"
              :loading="loading"
              :filtersDisabled="hierarchyLoading"
              :hasData="data.length > 0"
              :hasActiveFilters="Object.keys(activeFilters).length > 0"
              :page.sync="page"
              :meta="meta"
              :perpage="perpage"
              :hasEditRight="$nova.hasRight(right, 'edit')"
              :actualLabel="$nova.labelsName('materiality_page','actual_label','Actual')"
              :forecastLabel="$nova.labelsName('materiality_page','forecast_longform_label','Forecast')"
              @edit-data="handleEditData"
              @loadNextPage="loadNextPage"
              @update:filters="handleTableFilterUpdate"
              @filter-menu-open="handleFilterMenuOpen"
            />
            </div>
          </div>
       

      <MaterialityFAQ v-model="faqdialog" :loading="loading"  v-if="faqdialog" />

    </div>
<!-- 
    <MaterialitySet
    v-if="addeditrudialog"
    v-model="addeditrudialog"
    :loading="addeditruloading"
    :ruData="addeditrudata"
    :ruError="addeditruerror"
    :glData="addeditgldata"
    :glError="addeditglerror"
    :formattedGLData="formattedGLData"
    :formattedRUData="formattedRUData"
    :formattedRUErrorData="formattedRUErrorData"
    :cycle="cycle"
    :bulksubmit="bulksubmit"
    :isViewMode="isViewMode"
    :ruLevelEdit="ruleveledit"
    :editableGLs="editablegls"
    :glHeaders="glheaders"
    :minDate="minDate"
    :maxDate="maxDate"
    :multipleMaterialityToggle="multipleMaterialityToggle"
    :infoMessage="infoMessage"
    @update:ruData="addeditrudata = $event"
    @update:ruLevelEdit="ruleveledit = $event"
    @update:multipleMaterialityToggle="multipleMaterialityToggle = $event"
    @editGL="editablegls[$event.type].push($event.id)"
    @cancelEditGL="cancelEditItem($event.id, $event.type)"
    @removeMonth="removeMonth"
    @periods-changed="handlePeriodsChange"
    @updateRUThreshold="updateRUThreshold"
    @updateGLThreshold="updateGLThreshold"
    @updateSLThreshold="updateSLThreshold"
    :viewRULevelMaterialityData="ruLevelMaterialityData"
    :viewGLLevelMaterialityData="glLevelMaterialityData"
    :viewSLLevelMaterialityData="slLevelMaterialityData"
    
  /> -->

    <BulkMaterialityUpload
      v-if="bulkUploadDialog"
      v-model="bulkUploadDialog"
      :loading="bulksubmitruloading || bulksubmitglloading || bulksubmitslloading"
      :ruFileData="bulksubmitrufiledata"
      :ruFileError="bulksubmitrufileerror"
      :ruFileErrorFlag="bulksubmitrufileerrorflag"
      :glFileData="bulksubmitglfiledata"
      :glFileError="bulksubmitglfileerror"
      :glFileErrorFlag="bulksubmitglfileerrorflag"
      :slFileData="bulksubmitslfiledata"
      :slFileError="bulksubmitslfileerror"
      :slFileErrorFlag="bulksubmitslfileerrorflag"
      :fileProcessing="fileprocessing"
      :emptyRuCode="emptyRuCode"
      :initialTab="bulkUploadInitialTab"
      :initialCycleType="bulkCycleType"
      @generateTemplate="generateBulkSubmitFile"
      @fileChange="handleBulkFileChange"
      @cycleTypeChange="handleCycleTypeChange"
      @proceedUpload="handleBulkUploadProceed"
      @update:cycleType="bulkCycleType = $event"
    />

    <lb-dialog v-model="pendingdialog" heading="Pending approval list" width="80%" :loading="pendingloading" v-if="pendingdialog">
      <template v-slot:body>
        <div> 
          <ApprovalsList :data="pendingrequestlist" @loading="setPendingLoading" :key="new Date().getTime()" :showMateriality="false"/>
        </div>
      </template>
    </lb-dialog>
  </div>
</template>

<script>
let styledxlsx = require('sheetjs-style');
import ApprovalsList from "./IndividualApprovalsList.vue";
import { MaterialityHeader, BulkMaterialityUpload, MaterialityTable, MaterialityCountCard, MaterialityFAQ  } from '../components/Materiality';
// import cfilter from './Filter'


import varianceAnalysisConstants from '../constants.js';
import { mapGetters, mapActions } from 'vuex';
import { ensureAccessHierarchy, buildHierarchyMaps } from '../utils/helper';

export default {
  name: 'commentary_materiality',
  data: function(){
    return {
      pagename:"materiality_page",
      right: "commentary_materiality",
      page: 0,
      perpage: 25,
      loading: true,
      hierarchyLoading: true,
      data: [],
      dataMeta: { totalCount: 0 },
      searchtext: "",
      filterDebounceTimer: null,
      activeFilters: {},
      addeditrudialog: false,
      addeditruloading: false,
      addeditrudata: {},
      addeditruerror: {},
      addeditgldata: {},
      addeditglerror: {},
      updateuserdialog: false,
      addusertype: "",
      bulkchange: {},
      bulkchangeloading: false,
      bulkchangedialog: false,
      cycle:"",
      bulksubmit: false,
      filesubmit: false,
      singleupdatetype: false,
      gllist: {},
      glcodenamemap: {},
      glreportingtypemap: {},
      glcodeidmap: {},
      formattedGLData: [],
      allgls: [],
      editablegls: {proforma:[],forecast:[]},
      ruleveledit: {local: false, regional: false, enable: false},
      formatedData: [],
      rucodenamemap: {},
      rucodeidmap: {},
      bulkRuCodeNameMap: {},
      bulkRuCodeIdMap: {},
      // Name-to-ID mappings for filter conversion
      networkNameIdMap: {},
      regionNameIdMap: {},
      countryNameIdMap: {},
      // RU code filter list built from hierarchy data
      ruCodeFilterList: [],
      pendingrequestlist: [],
      pendingdialog: false,
      pendingloading: false,
      fileprocessing: {},
      headers: varianceAnalysisConstants.MATERIALITY.HEADERS.map(header => ({
        ...header,
        text: header.text === "S.No" ? "S.No" : 
              header.text === "RU Code" ? this.$nova.labelsName('materiality_page','commentary_ru_code_label','RU Code') :
              header.text === "Name" ? "Name" :
              header.text === "Network" ? this.$nova.labelsName('materiality_page','division_label','Network') :
              header.text === "Region" ? this.$nova.labelsName('materiality_page','region_label','Region') :
              header.text === "Country" ? this.$nova.labelsName('materiality_page','country_label','Country') :
              header.text === "Currency" ? "Currency" :
              header.text === "Created At" ? "Created At" :
              header.text === "Updated At" ? "Updated At" :
              header.text === "Action" ? this.$nova.labelsName('materiality_page','commentary_action_label','Action') : header.text
      })),
      glheaders: varianceAnalysisConstants.MATERIALITY.GL_HEADERS.map(header => ({
        ...header,
        text: header.text === "GL Code" ? this.$nova.labelsName('materiality_page','commentary_gl_code_label','GL Code') :
              header.text === "Name" ? "Name" :
              header.text === "LC Amt" ? this.$nova.labelsName('materiality_page','commentary_local_control_amount_shortform_label','LC Amt') :
              header.text === "LC %" ? this.$nova.labelsName('materiality_page','commentary_local_control_percentage_shortform_label','LC %') :
              header.text === "LM Amt" ? this.$nova.labelsName('materiality_page','commentary_local_management_amount_shortform_label','LM Amt') :
              header.text === "LM %" ? this.$nova.labelsName('materiality_page','commentary_local_management_precentage_shortform_label','LM %') :
              header.text === "RC Amt" ? this.$nova.labelsName('materiality_page','commentary_regional_control_amount_shortform_label','RC Amt') :
              header.text === "RC %" ? this.$nova.labelsName('materiality_page','commentary_regional_control_percentage_shortform_label','RC %') :
              header.text === "RM Amt" ? this.$nova.labelsName('materiality_page','commentary_regional_management_amount_shortform_label','RM Amt') :
              header.text === "RM %" ? this.$nova.labelsName('materiality_page','commentary_regional_management_percentage_shortform_label','RM %') : header.text
      })),
      faqContent: varianceAnalysisConstants.MATERIALITY.FAQ_CONTENT,
      faqdialog:false,
      emptyRuCode:false,
      addedgldatacopy:{},
      isMaterialitySet: true,
      infoMessage:"",
      isViewMode:false,
      minDate:'2023-1',
      maxDate:'2025-4',
      selectedRUId:'',
      multipleMaterialityToggle:false,
      formattedRUData:{},
      formattedRUErrorData:{},
      fydetails:{'start':'01','end':'12'},
      bulkCycleType:false,
      cycleTypeItem:[{name:this.$nova.labelsName('materiality_page','actual_label','Actual'),value:'Actual'},{name:this.$nova.labelsName('materiality_page','forecast_longform_label','Forecast'),value:'Forecast'}],
      control_thresholds_percent_proforma_value:this.$nova.labelsName('materiality_page','control_thresholds_percent',varianceAnalysisConstants.ThresholdPercent.DEFAULT_THRESHOLD_PERCENT),
      control_thresholds_percent_regional_proforma_value:this.$nova.labelsName('materiality_page','control_thresholds_percent_regional',varianceAnalysisConstants.ThresholdPercent.DEFAULT_THRESHOLD_PERCENT),
      wiseTabs: varianceAnalysisConstants.MATERIALITY.WISE_TABS.map(tab => ({
        label: this.$nova.labelsName('materiality_page', tab.labelKey, tab.labelFallback),
        value: tab.value
      })),
      selectedWiseTab: 0,
      multipleMaterialityToggleGL:false,
      multipleMaterialityToggleSL:false,
      multipleMaterialityToggleRU:false,
      materialitySLLevelType:'',
      bulkUploadDialog: false,
      bulkUploadInitialTab: 0,
      bulksubmitruloading: false,
      bulksubmitglloading: false,
      bulksubmitslloading: false,
      bulksubmitrufile: null,
      bulksubmitrubkpfile: null,
      bulksubmitrufiledata: [],
      bulksubmitrufileerror: [],
      bulksubmitrufileerrorflag: false,
      bulksubmitglfile: null,
      bulksubmitglbkpfile: null,
      bulksubmitglfiledata: [],
      bulksubmitglfileerror: [],
      bulksubmitglfileerrorflag: false,
      bulksubmitslfile: null,
      SelectedReportingType:null,
      bulksubmitslbkpfile: null,
      bulksubmitslfiledata: [],
      bulksubmitslfileerror: [],
      bulksubmitslfileerrorflag: false,
      // Stores selected column values for column visibility toggle
      visibleColumns: [],
      ruLevelMaterialityData: [],
      glLevelMaterialityData: [],
      slLevelMaterialityData: [],
    }
  },
  components: {
    ApprovalsList,
    MaterialityHeader,
    BulkMaterialityUpload,
    MaterialityCountCard,
    MaterialityTable,
    MaterialityFAQ,
    // MaterialityApprovalsList,
  },

  /**
   * Activated hook - called when component is activated (keep-alive)
   * Only refreshes if store is empty to avoid unnecessary API calls
   */
  activated() {
    // Only refresh if store doesn't have data
    if (!this.storeAllReportingUnits || this.storeAllReportingUnits.length === 0) {
      this.refreshData();
    } else {
      // Load data from store without API calls
      this.loadFromStore();
      // Ensure GL data is fetched if missing from store
      if (!this.storeGLCodeNameMap || Object.keys(this.storeGLCodeNameMap).length === 0) {
        this.fetchGLListAndUpdate();
      }
    }
    // Ensure access hierarchy is loaded for complete filter lists
    this.loadAccessHierarchy();
  },
  
  /**
   * Created hook - called when component is created
   * Initializes component state and loads data
   */
  created() {
    
    // Initialize visibleColumns with unlocked columns that have visible !== false
    this.visibleColumns = this.headers
      .filter(header => header.lock !== undefined && !header.lock && header.visible !== false)
      .map(header => header.value);
    
    // Calculate max date for materiality
    const today = new Date();
    if(today.getMonth() > this.fydetails.end){
      this.maxDate = (today.getFullYear()+1)+"-"+this.fydetails.end;
    }
    else if(today.getMonth() < this.fydetails.end){
      this.maxDate = (today.getFullYear())+"-"+this.fydetails.end;
    }

    // Load data from store if available, otherwise fetch from API
    if (this.storeAllReportingUnits && this.storeAllReportingUnits.length > 0) {
      this.loadFromStore();
      // Ensure GL data is fetched if missing from store
      if (!this.storeGLCodeNameMap || Object.keys(this.storeGLCodeNameMap).length === 0) {
        this.fetchGLListAndUpdate();
      }
    } else {
      this.refreshData();
    }
    // Load access hierarchy for complete filter lists
    this.loadAccessHierarchy();
  },
  
  /**
   * Mounted hook - called after component is mounted
   */
  mounted() {
  },
  
  /**
   * BeforeDestroy hook - cleanup component state
   * Note: Does NOT clear Vuex store to preserve data for navigation
   */
  beforeDestroy() {
    // Clear debounce timer to prevent memory leaks
    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
      this.filterDebounceTimer = null;
    }
    // Reset component-specific data to default values
    this.page = 0;
    this.faqdialog = false;
    this.pendingdialog = false;
    this.addeditrudialog = false;
    this.addeditruloading = false;
    this.selectedRUId = '';
    this.cycle = '';
    this.bulkCycleType = false;
    this.activeFilters = {};
    // Note: Store data is intentionally NOT cleared to support navigation flow
  },
  methods: {
    ...mapActions('varianceanalysis/reportingUnit', [
      'fetchAllReportingUnits',
      'fetchGLList',
      'fetchPendingApprovalRequests',
    ]),
    
    /**
     * Loads access hierarchy data (network, region, country) from the Vuex store.
     * If the hierarchy data already exists in the store, uses it directly.
     * If not, dispatches the fetchAccessHierarchy action and then populates local maps.
     * This ensures complete filter lists across all pages, not just the current page.
     */
    async loadAccessHierarchy() {
      this.hierarchyLoading = true;
      try {
        const hierarchyData = await ensureAccessHierarchy(this.$store, this.axios);
        const maps = buildHierarchyMaps(hierarchyData, {
          networkNameIdMap: this.networkNameIdMap,
          regionNameIdMap: this.regionNameIdMap,
          countryNameIdMap: this.countryNameIdMap,
        });
        this.networkNameIdMap = maps.networkNameIdMap;
        this.regionNameIdMap = maps.regionNameIdMap;
        this.countryNameIdMap = maps.countryNameIdMap;
        // Build RU code filter list from hierarchy data
        this.ruCodeFilterList = (hierarchyData.reportingunitlist || []).map(ru => ({
          name: `${ru.code} - ${ru.name}`,
          value: ru._id,
        }));
      } catch (error) {
        console.error('[Threshold]: loadAccessHierarchy error', error);
      } finally {
        this.hierarchyLoading = false;
      }
    },
    /**
     * Loads data from Vuex store without making API calls
     * Used when navigating back from AddMateriality to avoid unnecessary fetches
     */
    loadFromStore() {
      
      // Load reporting units from store
      this.data = this.storeAllReportingUnits || [];
      this.dataMeta = this.storeAllReportingUnitsMeta || { totalCount: 0 };
      
      // Load GL data from store
      this.gllist = this.storeGLList || {};
      this.glcodenamemap = this.storeGLCodeNameMap || {};
      this.glreportingtypemap = this.storeGLReportingTypeMap || {};
      this.glcodeidmap = this.storeGLCodeIdMap || {};
      this.allgls = this.storeAllGLs || [];
      
      // Load pending requests from store
      this.pendingrequestlist = this.storePendingApprovalRequests || [];
      
      // Format the data for display
      this.formateData();
      
      // Data is ready — stop loading
      this.loading = false;
    },
    /**
     * Fetches GL list from API and updates local data.
     * Called when GL data is missing from the store but RU data exists.
     */
    async fetchGLListAndUpdate() {
      try {
        await this.fetchGLList({ axiosInstance: this.axios });
        this.gllist = this.storeGLList || {};
        this.glcodenamemap = this.storeGLCodeNameMap || {};
        this.glreportingtypemap = this.storeGLReportingTypeMap || {};
        this.glcodeidmap = this.storeGLCodeIdMap || {};
        this.allgls = this.storeAllGLs || [];
      } catch (error) {
        console.error('[Threshold]: fetchGLListAndUpdate error', error);
      }
    },
    
    handlePeriodsChange(periods) {
        this.getRUData(periods[0])
      },
    /**
     * Refreshes all data by clearing filters and forcing API calls (bypasses cache)
     */
    refreshData() {
      this.activeFilters = {};
      // Reset name→ID maps on full refresh so stale entries don't persist
      this.networkNameIdMap = {};
      this.regionNameIdMap = {};
      this.countryNameIdMap = {};
      this.getData(true); // Pass forceRefresh=true to bypass cache
    },
    /**
     * Handles page navigation from pagination component.
     * Updates page and fetches the new page from the backend (server-side pagination).
     * @param {Object} d - Page data containing page number
     */
    loadNextPage(d) {
      const newPage = d?.page || 0;
      this.page = newPage;
      this.getFilteredData();
    },
    /**
     * Handles filter menu open event from MaterialityTable.
     * Loads full RU list from hierarchy store for the 'code' column filter.
     */
    handleFilterMenuOpen(key) {
      if (key === 'code') {
        const ruList = this.$store.state.m_varianceanalysis?.actualhierarchydata?.reportingunitlist
          || this.$store.state.varianceanalysis?.actualhierarchydata?.reportingunitlist || [];
        const filterList = ruList.map(ru => ({
          name: `${ru.code} - ${ru.name}`,
          value: ru._id,
        }));
        this.$refs.materialityTable?.setExternalFilterItems('code', filterList);
      }
    },
    /**
     * Handles table column filter updates with debounce
     * Maps filter selections to API parameters and fetches filtered data
     * @param {Object} filters - Filter object from DataTableNew with column filter selections
     */
    handleTableFilterUpdate(filters) {
      if (this.filterDebounceTimer) {
        clearTimeout(this.filterDebounceTimer);
      }

      this.filterDebounceTimer = setTimeout(async () => {
        // If filters is null or empty object, reset to default data
        if (!filters || Object.keys(filters).length === 0) {
          // If there are no active filters, nothing to clear — skip re-fetch
          if (Object.keys(this.activeFilters).length === 0) return;
          this.activeFilters = {};
          this.page = 0;
          await this.getFilteredData();
          return;
        }

        // Store active filters for pagination
        this.activeFilters = { ...filters };
        this.page = 0;

        await this.getFilteredData();
      }, 500); // 500ms debounce
    },
    /**
     * Builds a filter payload object combining pagination params with active column filters.
     * Converts display names to IDs so the backend can filter directly.
     * @returns {Object} Filter payload ready for the API: { limit, page, network?, region?, country?, ruids? }
     */
    buildFilterPayload() {
      const filterPayload = {
        limit: this.perpage,
        page: this.page,
      };

      // Map column filters to API parameters (convert names to IDs)
      if (this.activeFilters && Object.keys(this.activeFilters).length > 0) {
        // Network filter - convert names to IDs
        if (this.activeFilters.network?.length > 0) {
          filterPayload.network = this.activeFilters.network
            .map(name => this.networkNameIdMap[name])
            .filter(id => id);
        }

        // Region filter - convert names to IDs
        if (this.activeFilters.region?.length > 0) {
          filterPayload.region = this.activeFilters.region
            .map(name => this.regionNameIdMap[name])
            .filter(id => id);
        }

        // Country filter - convert names to IDs
        if (this.activeFilters.country?.length > 0) {
          filterPayload.country = this.activeFilters.country
            .map(name => this.countryNameIdMap[name])
            .filter(id => id);
        }

        // Code/RU Code filter - values are already _ids from external filter items
        if (this.activeFilters.code?.length > 0) {
          filterPayload.ruids = this.activeFilters.code.filter(id => id);
        }
      }

      return filterPayload;
    },
    /**
     * Fetches data with active filters applied.
     * Uses buildFilterPayload to combine pagination with column filters for the API request.
     */
    async getFilteredData() {
      this.loading = true;

      try {
        const filterPayload = this.buildFilterPayload();

        // Fetch reporting units with server-side pagination & filters
        await this.fetchAllReportingUnits({
          filter: filterPayload,
          axiosInstance: this.axios
        });

        // Update local data from store
        this.data = this.storeAllReportingUnits || [];
        this.dataMeta = this.storeAllReportingUnitsMeta || { totalCount: 0 };

        this.formateData();
      } catch (error) {
        console.error('[Threshold]: getFilteredData error', error);
      } finally {
        this.loading = false;
      }
    },
    setPendingLoading(v) {
      this.pendingloading = v;
    },
    /**
     * Opens the pending approval dialog and fetches fresh data
     * Called every time the pending approval list is opened
     */
    async openPendingApprovalDialog() {
      this.pendingdialog = true;
      this.pendingloading = true;
      await this.getPendingApprovalData();
      this.pendingloading = false;
    },
    /**
     * Fetches all data needed for the Threshold page
     * Uses Vuex store actions to fetch reporting units, GL list, and pending approvals
     * All API calls go through Vuex actions which handle success/error feedback
     * @param {boolean} forceRefresh - If true, bypasses cache and forces API calls
     */
    async getData(forceRefresh = false) {
      this.loading = true;
      
      try {
        // Build filter payload: always include pagination + any active column filters
        const filterPayload = this.buildFilterPayload();

        // Fetch reporting units with server-side pagination & filtering
        await this.fetchAllReportingUnits({
          filter: filterPayload,
          axiosInstance: this.axios,
          forceRefresh
        });

        // Update local data from store
        this.data = this.storeAllReportingUnits || [];
        this.dataMeta = this.storeAllReportingUnitsMeta || { totalCount: 0 };

        this.formateData();

        // Fetch GL list
        await this.fetchGLList({ axiosInstance: this.axios });

        // Update local GL data from store
        this.gllist = this.storeGLList || {};
        this.glcodenamemap = this.storeGLCodeNameMap || {};
        this.glreportingtypemap = this.storeGLReportingTypeMap || {};
        this.glcodeidmap = this.storeGLCodeIdMap || {};
        this.allgls = this.storeAllGLs || [];

        // Update local pending requests from store
        this.pendingrequestlist = this.storePendingApprovalRequests || [];
        
      } catch (error) {
        console.error('[Threshold]: getData error', error);
        // Error feedback is handled by Vuex actions
      } finally {
        this.loading = false;
      }
    },
    /**
     * Fetches pending approval requests using Vuex store
     */
    async getPendingApprovalData() {
      try {
        await this.fetchPendingApprovalRequests({ client: this.$store.state.client, axiosInstance: this.axios });
        this.pendingrequestlist = this.storePendingApprovalRequests;
      } catch (error) {
        console.error('[Threshold]: getPendingApprovalData error', error);
      }
    },
    formateData() {
      let ArrayTemp = [];
      this.rucodenamemap = {};
      this.rucodeidmap = {};
      // Accumulate name-to-id maps (don't reset) so filters survive page changes.
      // Maps are only reset in refreshData() when all filters are cleared.
      // Clone existing maps so Vue 2 detects the replacement as a reactive change.
      const newNetworkMap = { ...this.networkNameIdMap };
      const newRegionMap = { ...this.regionNameIdMap };
      const newCountryMap = { ...this.countryNameIdMap };
      
      // Calculate the row offset for indexno based on current page
      const pageOffset = this.page * this.perpage;
      
      this.data.forEach((i, k) => {
        this.rucodenamemap[i.code] = i.name?.trim();
        this.rucodeidmap[i.code] = i._id;
        
        // Build name-to-id mappings for filters (accumulated across pages)
        if (i.network_detail && i.network_detail.name && i.network_detail._id) {
          newNetworkMap[i.network_detail.name] = i.network_detail._id;
        }
        if (i.region_detail && i.region_detail.name && i.region_detail._id) {
          newRegionMap[i.region_detail.name] = i.region_detail._id;
        }
        if (i.country_detail && i.country_detail.name && i.country_detail._id) {
          newCountryMap[i.country_detail.name] = i.country_detail._id;
        }
        
        ArrayTemp.push({
          __key: k,
          __formatedkey: k,
          _id: i._id,
          indexno: pageOffset + k + 1,
          code: i.code,
          name: i.name,
          network: (i.network_detail || {}).name || "NA",
          region: (i.region_detail || {}).name || "NA",
          country: (i.country_detail || {}).name || "NA",
          currency: i.currency,
          created_at: this.toISOConverter(i.created_at)+" IST",
          updated_at: this.toISOConverter(i.updated_at)+" IST",
        });
      });
      
      // Replace maps with new objects so Vue 2 detects the change
      // (triggers filteredHeaders recompute → injects updated filterList on headers)
      this.networkNameIdMap = newNetworkMap;
      this.regionNameIdMap = newRegionMap;
      this.countryNameIdMap = newCountryMap;
      
      this.formatedData = ArrayTemp;
    },
    /**
     * Handle edit data event from MaterialityTable component
     * Sets all materiality data in Vuex store before navigating to AddMateriality page
     * @param {Object} payload - Event payload with item, cycleType, editType, ruId/selected, isViewMode
     */
    handleEditData(payload) {
      
      // Validate payload structure
      if (!payload) {
        console.error('[Threshold]: Invalid payload received', payload);
        this.$store.commit('sbError', 'Invalid data received. Please try again.', { root: true });
        return;
      }

      // Generate formatted GL data if not already available
      if (this.formattedGLData.length === 0 && this.gllist && Object.keys(this.gllist).length > 0) {
        this.formattedGLData = this.generateFormattedGLList({}, true);
      }
      
      let sanitizedPayload;
      
      // Handle bulk edit vs single edit
      if (payload.editType === 'bulk' && payload.selected && payload.selected.length > 0) {
        // For bulk edit, store the selected IDs array
        sanitizedPayload = {
          cycleType: payload.cycleType,
          editType: 'bulk',
          selected: payload.selected,
          isViewMode: payload.isViewMode || false
        };
        
      } else if (payload.item) {
        // For single edit, sanitize and store the single item
        sanitizedPayload = {
          ...payload,
          item: {
            _id: payload.item._id,
            code: payload.item.code,
            name: payload.item.name,
            network: payload.item.network,
            region: payload.item.region,
            country: payload.item.country,
            currency: payload.item.currency
          }
        };
        
      } else {
        console.error('[Threshold]: Invalid payload - missing item or selected', payload);
        this.$store.commit('sbError', 'Invalid data received. Please try again.', { root: true });
        return;
      }
      
      // Store the sanitized payload
      this.$store.commit('varianceanalysis/reportingUnit/SET_EDITING_MATERIALITY_PAYLOAD', sanitizedPayload);
      
      // Store additional materiality data needed by AddMateriality component
      this.$store.commit('varianceanalysis/reportingUnit/SET_MATERIALITY_GL_LIST', this.gllist);
      this.$store.commit('varianceanalysis/reportingUnit/SET_MATERIALITY_FORMATTED_GL_DATA', this.formattedGLData);
      this.$store.commit('varianceanalysis/reportingUnit/SET_MATERIALITY_ADDEDIT_GL_DATA', this.addeditgldata);
      this.$store.commit('varianceanalysis/reportingUnit/SET_MATERIALITY_FORMATTED_RU_DATA', this.formattedRUData);
      this.$store.commit('varianceanalysis/reportingUnit/SET_MATERIALITY_FORMATTED_RU_ERROR_DATA', this.formattedRUErrorData);
      
      // Store RU/GL/SL level materiality data for view mode
      this.$store.commit('varianceanalysis/reportingUnit/SET_VIEW_RU_LEVEL_MATERIALITY_DATA', this.ruLevelMaterialityData);
      this.$store.commit('varianceanalysis/reportingUnit/SET_VIEW_GL_LEVEL_MATERIALITY_DATA', this.glLevelMaterialityData);
      this.$store.commit('varianceanalysis/reportingUnit/SET_VIEW_SL_LEVEL_MATERIALITY_DATA', this.slLevelMaterialityData);
      
      this.$nova.gotoLink({ path: '/varianceanalysis/addthreshold' });
    },
    editData(v, cycle, type, ru,isView=false) {
      this.cycle = cycle;
      this.selectedRUId = ru;
      this.editablegls = {proforma:[],forecast:[]};
      this.isMaterialitySet=true;
      this.formattedRUData = {}
      this.formattedRUErrorData = {};
      this.multipleMaterialityToggle = false
      this.bulksubmitrufile = null;
      this.bulksubmitglfile = null;
      const today = new Date();
      if(!isView){
        this.ruleveledit.local = true;
        this.ruleveledit.regional = true;
        this.ruleveledit.enable = true;
      }else{
        this.ruleveledit.local = false;
        this.ruleveledit.regional = false;
        this.ruleveledit.enable = false;
        today.setMonth(today.getMonth() - 24); // Subtract 24 months
      }
      this.isViewMode = isView
      
      if(type === "bulk") {
        this.infoMessage='Multiple materiality thresholds set at GL level'
        this.bulksubmit = true;
        this.filesubmit = false;
        this.addeditrudata={};
        this.addeditrudata.__type = type;
        this.addeditruerror={};
      }
      else if(type === "single") {
        this.infoMessage='Multiple materiality thresholds set at GL level'
        this.bulksubmit = false;
        this.filesubmit = false;
        this.addeditrudata=this.$nova.deepCopyJson(v);
        this.addeditrudata.__type = type;
        this.addeditruerror={};
        if(this.addeditrudata.control_thresholds_percent) this.addeditrudata.control_thresholds_percent = this.addeditrudata.control_thresholds_percent*100;
        if(this.addeditrudata.management_thresholds_percent) this.addeditrudata.management_thresholds_percent = this.addeditrudata.management_thresholds_percent*100;
      }
      else if(type === "rufile" || type === "glfile" || type === "slfile") {
        this.bulksubmit = false;
        this.filesubmit = true;
        this.addeditrudata={};
        this.addeditrudata.__type = type;
        this.addeditruerror={};
        this.bulksubmitrufiledata = [];
        this.bulksubmitglfiledata = [];
        this.bulksubmitrufileerror = [];
        this.bulksubmitglfileerror = [];
        this.bulksubmitslfileerror = [];
        this.bulksubmitrufileerrorflag = false;
        this.bulksubmitglfileerrorflag = false;
        this.bulksubmitslfileerrorflag = false;
        this.emptyRuCode=false
        this.bulkCycleType=false;
        if(type === "rufile") this.bulksubmitrudialog = true;
        else if(type === "glfile") this.bulksubmitgldialog = true;
        else if(type === "slfile") this.bulksubmitsldialog = true;
      }
      if(type === "bulk" || type === "single"){
        const defaultThreshold = varianceAnalysisConstants.DEFAULTS.THRESHOLD_VALUE;
        this.addeditrudata._id = ru;
        
        // Initialize all threshold keys with default values using constants
        varianceAnalysisConstants.MATERIALITY.THRESHOLD_KEYS.forEach(key => {
          // Use specific values for control percent keys, otherwise default
          if (key === 'control_thresholds_percent_proforma') {
            this.addeditrudata[key] = this.control_thresholds_percent_proforma_value;
          } else if (key === 'control_thresholds_percent_regional_proforma') {
            this.addeditrudata[key] = this.control_thresholds_percent_regional_proforma_value;
          } else {
            this.addeditrudata[key] = defaultThreshold;
          }
        });

        this.addeditrudialog=true;
        if(ru instanceof Array || !this.isViewMode) this.formattedGLData = this.generateFormattedGLList({},true);
        else this.getRUData(ru);
      }
    },
    updateRUThreshold(){
      this.singleupdatetype = false;
      this.materialitySLLevelType = '';
      this.updateThreshold();
    },
    updateGLThreshold(){
      this.singleupdatetype = true;
      this.materialitySLLevelType = '';
      this.updateThreshold()
    },
    updateSLThreshold(){
      this.singleupdatetype = false;
      this.materialitySLLevelType = 'materialitysllevel'
      this.updateThreshold()
    },
    updateThreshold() {
      this.addeditruloading = true;
      let actualKeys = varianceAnalysisConstants.MATERIALITY.ACTUAL_KEYS;
      let dataValues = varianceAnalysisConstants.MATERIALITY.DATA_VALUES;
      let forecastKeys = varianceAnalysisConstants.MATERIALITY.FORECAST_KEYS;
      let periodList = this.addeditrudata?.periods?.map(item => item.split('-').reverse().join('-')) || null;
      this.addeditrudata.periods = periodList
      let newdata = {
        cycle: this.cycle,
        periods: this.addeditrudata.periods, 
        reportingunit: this.addeditrudata._id || '',
        multiplematerialities:true,
        reporting_type: this.addeditrudata.reporting_type
      };
      if(this.ruleveledit.enable){
        newdata.threshold = {
          control_thresholds_enable: this.addeditrudata.control_thresholds_enable || false,
          management_thresholds_enable: this.addeditrudata.management_thresholds_enable || false,
          control_thresholds_regional_enable: this.addeditrudata.control_thresholds_regional_enable || false,
          management_thresholds_regional_enable: this.addeditrudata.management_thresholds_regional_enable || false,
        }
      }
      if(this.addeditrudata.__type === "rufile") {
        this.bulksubmitruloading = true;
        newdata.type = "filematerialityrulevel";
        newdata.reporting_type = this.addeditrudata.reporting_type;
        newdata.bulk = true;
        let ndt = [];
        newdata.reportingunit = [];
        let isactualdata = false;
        let isforecastdata = false;
        for (const i of this.bulksubmitrufiledata) {
          let actual = {};
          let forecast = {};
          let td = {};
          td.rucode = (this.bulkRuCodeIdMap[i.rucode] || this.rucodeidmap[i.rucode]);
          newdata.reportingunit.push(td.rucode);
          td.period= i.period
          actualKeys.forEach((value,index)=>{
            if(Object.prototype.hasOwnProperty.call(i, value)){
              actual[dataValues[index]] = i[value] ?? 0;
              isactualdata = true
            } 
          });
          forecastKeys.forEach((value,index)=>{
            if(Object.prototype.hasOwnProperty.call(i, value)){ 
              forecast[dataValues[index]] = i[value] ?? 0;
              isforecastdata = true
            }
          });
          if(isactualdata && isforecastdata) {
            newdata.cycle = "Both"
          }else if(isactualdata) {
            newdata.cycle = "Actual"
          }else if(isforecastdata){
            newdata.cycle = "Forecast"
          }
          td.actual = actual;
          td.forecast = forecast;
          ndt.push(td);
        }
        newdata.materiality = ndt;
      }
      else if(this.addeditrudata.__type === "glfile") {
        this.bulksubmitglloading = true;
        newdata.type = "filematerialitygllevel";
        newdata.bulk = true;
        newdata.reporting_type = this.addeditrudata.reporting_type;
        let ndt = [];
        let rudetails = {};
        let isactualdata = false;
        let isforecastdata = false;
        for (const i of this.bulksubmitglfiledata) {
          let actual = {};
          let forecast = {};
          let td = {};
          // td.rucode = this.rucodeidmap[i.rucode];
          td.glcode = this.glcodeidmap[i.glcode];
          td.period= i.period
          actualKeys.forEach((value,index)=>{
            if(Object.prototype.hasOwnProperty.call(i, value)){
              actual[dataValues[index]] = i[value] ?? 0;
              isactualdata = true
            }
          });
          forecastKeys.forEach((value,index)=>{
            if(Object.prototype.hasOwnProperty.call(i, value)){
              forecast[dataValues[index]] = i[value] ?? 0;
              isforecastdata = true;
            }
          });
          if(isactualdata && isforecastdata) {
            newdata.cycle = "Both"
          }else if(isactualdata) {
            newdata.cycle = "Actual"
          }else if(isforecastdata){
            newdata.cycle = "Forecast"
          }
          td.actual = actual;
          td.forecast = forecast;
          rudetails[(this.bulkRuCodeIdMap[i.rucode] || this.rucodeidmap[i.rucode])] = rudetails[(this.bulkRuCodeIdMap[i.rucode] || this.rucodeidmap[i.rucode])] || [];
          rudetails[(this.bulkRuCodeIdMap[i.rucode] || this.rucodeidmap[i.rucode])].push(td);
        }
        newdata.reportingunit = [];
        for (const k in rudetails) {
          if (Object.hasOwnProperty.call(rudetails, k)) {
            const el = rudetails[k];
            ndt.push({rucode: k, data: el});
            newdata.reportingunit.push(k);
          }
        }
        newdata.materiality = ndt;
      }
      else if(this.addeditrudata.__type === "slfile") {
        this.bulksubmitslloading = true;
        newdata.type = "filematerialitysllevel";
        newdata.bulk = true;
        newdata.reporting_type = this.addeditrudata.reporting_type;
        let ndt = [];
        let rudetails = {};
        let isactualdata = false;
        let isforecastdata = false;
        for (const i of this.bulksubmitslfiledata) {
          let actual = {};
          let forecast = {};
          let td = {};
          td.glcode = this.glcodeidmap[i.glcode];
          td.period= i.period
          actualKeys.forEach((value,index)=>{
            if(Object.prototype.hasOwnProperty.call(i, value)){
              actual[dataValues[index]] = i[value] ?? 0;
              isactualdata = true
            }
          });
          forecastKeys.forEach((value,index)=>{
            if(Object.prototype.hasOwnProperty.call(i, value)){
              forecast[dataValues[index]] = i[value] ?? 0;
              isforecastdata = true;
            }
          });
          if(isactualdata && isforecastdata) {
            newdata.cycle = "Both"
          }else if(isactualdata) {
            newdata.cycle = "Actual"
          }else if(isforecastdata){
            newdata.cycle = "Forecast"
          }
          td.actual = actual;
          td.forecast = forecast;
          rudetails[(this.bulkRuCodeIdMap[i.rucode] || this.rucodeidmap[i.rucode])] = rudetails[(this.bulkRuCodeIdMap[i.rucode] || this.rucodeidmap[i.rucode])] || [];
          rudetails[(this.bulkRuCodeIdMap[i.rucode] || this.rucodeidmap[i.rucode])].push(td);
        }
        newdata.reportingunit = [];
        for (const k in rudetails) {
          if (Object.hasOwnProperty.call(rudetails, k)) {
            const el = rudetails[k];
            ndt.push({rucode: k, data: el});
            newdata.reportingunit.push(k);
          }
        }
        newdata.materiality = ndt;
      }
      else if(this.materialitySLLevelType === 'materialitysllevel'){
        newdata.type = "materialitysllevel";
        if(this.bulksubmit) {
          newdata.bulk = true;
          newdata.type = "bulkmaterialitysllevel";
        }
        let ndt = [];
        let uniqueeditablegls = Array.from(new Set(this.editablegls.proforma.concat(this.editablegls.forecast)));
        const defaultThreshold = varianceAnalysisConstants.DEFAULTS.THRESHOLD_VALUE;

        for (const i of uniqueeditablegls) {
          Object.keys(this.addeditgldata[i]).forEach(key => {
            if (this.addeditgldata[i][key] === defaultThreshold) {
              delete this.addeditgldata[i][key];
            }
          });
          let td = {...(this.addeditgldata[i] || {})}
          td.glcode = i;
          ndt.push(td);
        }
        newdata.materiality = ndt;

      }
      else if(this.singleupdatetype){
        newdata.type = "materialitygllevel";
        if(this.bulksubmit) {
          newdata.bulk = true;
          newdata.type = "bulkmaterialitygllevel";
        }
        let ndt = [];
        let uniqueeditablegls = Array.from(new Set(this.editablegls.proforma.concat(this.editablegls.forecast)));
        const defaultThreshold = varianceAnalysisConstants.DEFAULTS.THRESHOLD_VALUE;

        for (const i of uniqueeditablegls) {
          Object.keys(this.addeditgldata[i]).forEach(key => {
            if (this.addeditgldata[i][key] === defaultThreshold) {
              delete this.addeditgldata[i][key];
            }
          });
          let td = {...(this.addeditgldata[i] || {})}
          td.glcode = i;
          ndt.push(td);
        }
        newdata.materiality = ndt;
      }else{
        newdata.type = "materialityrulevel";
        newdata.materiality = {}
        const defaultThreshold = varianceAnalysisConstants.DEFAULTS.THRESHOLD_VALUE;
        if(this.bulksubmit) {
          newdata.bulk = true;      
          newdata.type = "bulkmaterialityrulevel";
        }
        if(this.multipleMaterialityToggle && ['materialityrulevel','bulkmaterialityrulevel'].indexOf(newdata.type) !== -1){
          newdata['materiality']= this.formattedRUData
          if(this.addeditrudata.periods && Array.isArray(this.addeditrudata.periods)) {
            this.addeditrudata.periods.forEach((period)=>{
              dataValues.forEach(key=>{
                if(newdata.materiality[period]?.[key] && newdata.materiality[period][key] === defaultThreshold){
                  delete newdata.materiality[period][key];
                }
              })
              if(Object.entries(newdata.materiality[period]).length <= 2){
                delete newdata.materiality[period];
              }
            })
          }
          newdata.multiplematerialities=true
        }else if(!this.multipleMaterialityToggle && ['materialityrulevel','bulkmaterialityrulevel'].indexOf(newdata.type) !== -1){
          let data ={}
          newdata["materiality"] = {}
          dataValues.forEach(key=>{
            newdata['materiality'][key] = this.addeditrudata[key] ?? defaultThreshold
          })
          dataValues.forEach(key=>{
          if(newdata.materiality[key] === defaultThreshold){
            delete newdata.materiality[key];
          }
          });
          if(this.addeditrudata.periods && Array.isArray(this.addeditrudata.periods)) {
            this.addeditrudata.periods.forEach((period) => {
              data = {
                ...data,
                [period]: newdata.materiality // Use computed property name to set `period` as key
              };
            });
          }
          newdata.materiality = data
          newdata.multiplematerialities=false
        }
        else{
          dataValues.forEach(key=>{
          if(newdata.materiality[key] === defaultThreshold){
            delete newdata.materiality[key];
          }
        }
      )}
      }
      this.axios.post("/v2/varianceanalysis/materiality/saveupdateforapproval", {data: newdata}).then(dt => {
        if(dt.data.status === "success") {
          this.$store.commit("sbSuccess", "Bulk Materiality uploaded successfully");
          this.addeditrudialog = false;
          this.bulksubmitrudialog = false;
          this.bulksubmitgldialog = false;
          this.bulksubmitsldialog = false;
          this.bulkUploadDialog = false;
        }else throw new Error (dt.data.message || "Error raising change request");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
      }).finally(() => {
        this.addeditruloading = false;
        this.bulksubmitruloading = false;
        this.bulksubmitglloading = false;
        this.bulksubmitslloading = false;
        this.getPendingApprovalData();
      })
    },
    generateFormattedGLList(dt,ismulti=false){
      let ArrayTemp = [];
      this.addeditgldata = {};
      this.addeditglerror = {};
      (this.gllist["primary"] || []).forEach((i) => {
        this.addeditgldata[i._id] = this.getFormatedGLData(dt[i._id],ismulti);
        this.addeditglerror[i._id] = {};
        ArrayTemp.push(i);
        (this.gllist[i.code] || []).forEach((ii) => {
          ii.__child = true;
          this.addeditgldata[ii._id] = this.getFormatedGLData(dt[ii._id],ismulti);
          this.addeditglerror[ii._id] = {};
          ArrayTemp.push(ii);
        });
      });
      this.addeditgldatacopy = JSON.parse(JSON.stringify(this.addeditgldata));
      return ArrayTemp;
    },
    getFormatedGLData(i = {}, ismulti=false){
      const thresholdKeys = varianceAnalysisConstants.MATERIALITY.THRESHOLD_KEYS;
      const defaultThreshold = varianceAnalysisConstants.DEFAULTS.THRESHOLD_VALUE;
      const controlPercentValue = varianceAnalysisConstants.DEFAULTS.CONTROL_PERCENT_VALUE;
      let data = {}
      if(ismulti){
        thresholdKeys.forEach(key => {
            data[key] = defaultThreshold;
          });
      }else{
        thresholdKeys.forEach(key => {
          if(this.isViewMode){
            data[key] = i[key] || 0;
          }else{
            data[key] = defaultThreshold;
          }
        });
      }
      data['control_thresholds_percent_proforma'] = controlPercentValue;
      data['control_thresholds_percent_regional_proforma'] = controlPercentValue;
      return data;

    },
    reorder(dt, key){
      return dt.sort(function(a,b){return a[key] - b[key];});
    },

    generateBulkSubmitFile(key, reportingType) {
      return Promise.resolve().then(() => {
          const isBS = reportingType === 'bs';
          const workbook = styledxlsx.utils.book_new();
          // ========== SHEET: Instructions ==========
          let instructionsData;
          let startIndex;
          let headers;
          let preHeaders;
          let subHeaderFills;
          
          if(key === "rufile") {
            instructionsData = this.$constants.BULK_FILE_TEMPLATES.BULK_MATERIALITY_RU_LEVEL_UPLOAD_INSTRUCTIONS;
            startIndex = 4;
            headers = this.$constants.BULK_FILE_TEMPLATES.BULK_MATERIALITY_RU_LEVEL_UPLOAD;
            subHeaderFills = {
            "E1": "FFF8CBAD", // Light orange
            "E2": "FFB4C7E7", // Purple-ish
            "M2": "FFFFE699"  // Light yellow
          };
          } else if(key === "glfile" || key === "slfile") {
            instructionsData = this.$constants.BULK_FILE_TEMPLATES.BULK_MATERIALITY_GL_LEVEL_UPLOAD_INSTRUCTIONS;
            startIndex = 6;
            headers = this.$constants.BULK_FILE_TEMPLATES.BULK_MATERIALITY_GL_LEVEL_UPLOAD;
            subHeaderFills = {
              "G1": "FFF8CBAD", // Light orange
              "G2": "FFB4C7E7", // Purple-ish
              "O2": "FFFFE699"  // Light yellow
            };
          }

          const bsActual = this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual');
          const plActual = this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
          const bsProforma = this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma');
          const plProforma = this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
          const bsForecast = this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast');
          const plForecast = this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
          const actualLbl = isBS ? bsActual : plActual;
          const proformaLbl = isBS ? bsProforma : plProforma;
          const forecastLbl = isBS ? bsForecast : plForecast;

          if (this.bulkCycleType) {
            // Forecast Cycle
            preHeaders = [[...Array(startIndex).fill(""), `${forecastLbl} cycle`],
            [...Array(startIndex).fill(""), `${forecastLbl} Vs ${proformaLbl}`,
             null, null, null, null, null, null, null, `${forecastLbl} Vs Previous ${forecastLbl}`]];
          } else {
            // Actual Cycle
            preHeaders = [[...Array(startIndex).fill(""), `${actualLbl} cycle`],
            [...Array(startIndex).fill(""), `${actualLbl} Vs ${proformaLbl}`,
             null, null, null, null, null, null, null, `${actualLbl} Vs ${forecastLbl}`]];
          }

          headers = headers.map((label) => this.$nova.identifyAndRemapLabelName(this.$constants.BULK_FILE_TEMPLATES.LABELS_PAGE, label));
          instructionsData = instructionsData.map((item) => {
            item[1] = this.$nova.identifyAndRemapLabelName(this.$constants.BULK_FILE_TEMPLATES.LABELS_PAGE, item[1], true);
            return item;
            });
          const ws1 = styledxlsx.utils.aoa_to_sheet(instructionsData);
          ws1["B2"].s = {
            font: { bold: true } 
          };
          ws1["!merges"] = [{ s: { r: 11, c: 1 }, e: { r: 11, c: 11 } }]
          ws1["B12"].s = {
            fill: { patternType: "solid", fgColor: { rgb: "FFFF00" } },
            font: { 
              bold: true
            },
          };

          styledxlsx.utils.book_append_sheet(workbook, ws1, "Instructions");

          // ========== SHEET: TOP SHEET ==========
          const topData = [
            ...preHeaders,
            [...headers],
          ];
          for(let i = 0; i < 15; i++) {
            topData.push([...Array(startIndex + 15).fill("")]);
          }
          const ws2 = styledxlsx.utils.aoa_to_sheet(topData);

          // Merged cells
          ws2["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 1, c: startIndex - 1 } }, // A1:E2
            { s: { r: 0, c: startIndex }, e: { r: 0, c: startIndex + 15 } }, // F1:U1
            { s: { r: 1, c: startIndex }, e: { r: 1, c: startIndex + 7 } }, // F2:M2
            { s: { r: 1, c: startIndex + 8 }, e: { r: 1, c: startIndex + 15 } }, // N2:U2
          ];

          // Set column widths to match content
          ws2['!cols'] = [];
          // Set default width for all columns based on content in row 3
            for (const col of topData[2]) {
            const content = String(col || '');
            const width = Math.max(10, content.length * 1.2);
            ws2['!cols'].push({ width });
          }

          // Styling
          const headerFill = {
            patternType: "solid",
            fgColor: { rgb: "FF2F5597" }  // Blue-ish header
          };


          // Apply fill to merged header
          ["A1", "A3", "B3", "C3", "D3", "E3", "F3", "G3", "H3", "I3", "J3", "K3", "L3", "M3", "N3", "O3", "P3", "Q3", "R3", "S3", "T3", "U3", "V3"].forEach(cell => {
            if (ws2[cell]) ws2[cell].s = { font: { bold: true, color: { rgb: "FFFFFF" }}, alignment: {
                horizontal: "center",
                vertical: "center"
              }, fill: headerFill };
          });

          Object.entries(subHeaderFills).forEach(([cell, color]) => {
            if (ws2[cell]) ws2[cell].s = {
              font: { bold: true },
              fill: {
                patternType: "solid",
                fgColor: { rgb: color }
              },
              alignment: {
                horizontal: "center",
                vertical: "center"
              }
            };
          });

          // Add borders to all cells in the first 10 rows and up to startIndex + 15 columns
          const borderStyle = { style: "medium", color: { rgb: "000000" } };
          // Ensure all target cells have borders and are set to text format
          for (let r = 0; r < 18; r++) {
            for (let c = 0; c <= startIndex + 15; c++) {
              const cellRef = styledxlsx.utils.encode_cell({ r, c });

              // Initialize cell if it doesn't exist
              if (!ws2[cellRef]) {
                ws2[cellRef] = { v: "", t: "s" }; // 't: "s"' ensures it's treated as string
              }

              // Ensure style object exists
              if (!ws2[cellRef].s) ws2[cellRef].s = {};

              // Set border and number format
              ws2[cellRef].s.border = {
                top: borderStyle,
                bottom: borderStyle,
                left: borderStyle,
                right: borderStyle
              };

              if (c === (startIndex- 1)) {
                ws2[cellRef].s.numFmt = "@";
                ws2[cellRef].t = "s"; // Text type
              }
            }
          }

          styledxlsx.utils.book_append_sheet(workbook, ws2, "TOP SHEET");

          // Export file
          let levelName = 'GL_Level';
          if (key === "rufile") {
            levelName = 'RU_Level';
          } else if (key === "slfile") {
            levelName = 'SL_Level';
          }
          styledxlsx.writeFile(workbook, `${this.bulkCycleType ? forecastLbl : actualLbl}_Template_Materiality_${levelName}.xlsx`);

      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
      }).finally(() => {
        // Nothing to do here
      })
    },

    readBulkSubmitFile(key) {
      this.emptyRuCode=false
      let file = null;
      let cycleTypeIndex = 3;
      if(key === "rufile") file = this.bulksubmitrufile;
      else if(key === "glfile") file = this.bulksubmitglfile;
      else if(key === "slfile") file = this.bulksubmitslfile;
      if ((file || {}).name && (this.fileprocessing[key] || 0) === 0) {
        let headings = [];
        if (key === "rufile") {
          headings = this.$constants.BULK_FILE_TEMPLATES.BULK_MATERIALITY_RU_LEVEL_UPLOAD;
          cycleTypeIndex = 4;
        }
        else if (key === "glfile" || key === "slfile") {
          headings = this.$constants.BULK_FILE_TEMPLATES.BULK_MATERIALITY_GL_LEVEL_UPLOAD;
          cycleTypeIndex = 6;
        }
        // modify headings per the client
        headings = headings.map((label) => this.$nova.identifyAndRemapLabelName(this.$constants.BULK_FILE_TEMPLATES.LABELS_PAGE, label));
        this.bulksubmitruloading = true;
        this.bulksubmitglloading = true;
        this.bulksubmitslloading = true;
        this.fileprocessing[key] = 1;
        this.bulksubmitrufiledata = [];
        this.bulksubmitglfiledata = [];
        this.bulksubmitslfiledata = [];
        this.bulksubmitrufileerror = [];
        this.bulksubmitglfileerror = [];
        this.bulksubmitslfileerror = [];
        let visitedRuCodes = [];
        let visitedGlCodes = {};
        let ext = ((file || {}).name || "").split(".").pop();
        Promise.resolve().then(() => {
          if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) throw new "Only xlsx,xls,xlsm,xlsb file extension supported";
          return this.$nova.readExcelFile(file, "TOP SHEET");
        }).then(dt => {

          const isBS = this.SelectedReportingType === 'bs';
          const actualCheckLabel = isBS
            ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
            : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
          const forecastCheckLabel = isBS
            ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
            : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
          if (dt.length > 2 && dt[0][cycleTypeIndex] && ((!this.bulkCycleType && dt[0][cycleTypeIndex].includes(actualCheckLabel)) || (this.bulkCycleType && dt[0][cycleTypeIndex].includes(forecastCheckLabel)))) { 
            if (JSON.stringify(dt[2] || []) === JSON.stringify(headings)) {
              let filedata = [];
              let errordata = [];
              this.bulksubmitrufileerrorflag = false;
              this.bulksubmitglfileerrorflag = false;
              this.bulksubmitslfileerrorflag = false;
              let invalidData = {};
              // Build full RU code map from hierarchy data (not paginated this.data)
              const fullRuList = this.$store.state.m_varianceanalysis?.actualhierarchydata?.reportingunitlist
                || this.$store.state.varianceanalysis?.actualhierarchydata?.reportingunitlist || [];
              const fullRuCodeNameMap = {};
              const fullRuCodeIdMap = {};
              fullRuList.forEach(ru => {
                fullRuCodeNameMap[ru.code] = ru.name?.trim();
                fullRuCodeIdMap[ru.code] = ru._id;
              });
              // Store for use during bulk submit
              this.bulkRuCodeNameMap = fullRuCodeNameMap;
              this.bulkRuCodeIdMap = fullRuCodeIdMap;
              for (let i = 2; i < dt.length; i++) {
                if (i > 2) {
                  invalidData = { 'actual_local_proforma_error_data':0,'actual_regional_proforma_error_data':0,'actual_local_forecast_error_data':0,'actual_regional_forecast_error_data':0,
                      'forecast_local_proforma_error_data':0,'forecast_regional_proforma_error_data':0,'forecast_local_forecast_error_data':0,'forecast_regional_forecast_error_data':0,'general':0};
                  const el = dt[i];
                  let errorFormatData = {}
                  if(el.join("") !== ""){
                    let errors = {};
                    let startindex = 4; // Increased by 1 since we now have month and year as separate columns
                    let rowdata = {}
                    if(el[0]=== 0){
                      this.emptyRuCode=true
                    }
                    rowdata = {"rucode": (el[0]?.trim() || "").toUpperCase(), "runame": fullRuCodeNameMap[(el[0]?.trim() || "").toUpperCase()] || el[1]?.trim() || ""};
                  
                  // Get the month and year values
                  let periodIndex = key === 'rufile'? 2 : 4
                  let months = (el[periodIndex]?.toString().trim() || "").split(",").map(m => m.trim());
                  let year = el[periodIndex+1]?.toString().trim() || "";

                    if (!fullRuCodeNameMap[rowdata.rucode]) {errors.rucode = "RU Code not found";invalidData.general++}
                    if (rowdata.rucode === ""){errors.rucode = "Missing RU Code",invalidData.general++}
                  // Validate year format
                  if (!year || !/^\d{4}$/.test(year)) {
                    errors.year = "Invalid Year Format";
                    invalidData.general++;
                    this.bulksubmitrufileerrorflag = true;
                    this.bulksubmitglfileerrorflag = true;
                    this.bulksubmitslfileerrorflag = true;
                  }
                  
                  // Validate month format and values
                  if (!months.length || months[0] === "") {
                    errors.month = "Missing month values";
                    invalidData.general++;
                    this.bulksubmitrufileerrorflag = true;
                    this.bulksubmitglfileerrorflag = true;
                    this.bulksubmitslfileerrorflag = true;
                  } else {
                    for (let month of months) {
                    if (!/^(0?[1-9]|1[0-2])$/.test(month)) {
                      errors.month = "Invalid month format";
                      invalidData.general++;
                      this.bulksubmitrufileerrorflag = true;
                      this.bulksubmitglfileerrorflag = true;
                      this.bulksubmitslfileerrorflag = true;
                      break;
                    }
                    }
                  }
                  
                  // Process each month for the row
                  const processedRows = [];
                  
                  for (let month of months) {
                    if (month && year) {
                    // Pad month with leading zero if needed
                    month = month.padStart(2, '0');
                    
                    let periodStr = `${month}-${year}`;
                    let currentRowData = {...rowdata, period: periodStr};
                    
                    if(key === 'rufile'){
                      if (visitedRuCodes.indexOf(currentRowData.rucode+periodStr) !== -1) {
                      errors.rucode = "Duplicated RU Code in uploaded data for period " + periodStr;
                      invalidData.general++;
                      }
                      visitedRuCodes.push(currentRowData.rucode+periodStr);
                    }
                    
                    if(key === "glfile" || key === "slfile") {
                      startindex = 6; // Adjusted for GL code
                      currentRowData.glcode = (el[2]?.toString() || "").trim();
                      currentRowData.glname = this.glcodenamemap[currentRowData.glcode] || "";
                      if (!visitedGlCodes[currentRowData.rucode] && typeof currentRowData.glcode !== undefined) {
                        visitedGlCodes[currentRowData.rucode] = [];
                      }
                      if (!this.glcodenamemap[currentRowData.glcode]) {errors["glcode"] = "GL Code not found";invalidData.general++}
                      if (typeof currentRowData.glcode === undefined || currentRowData.glcode === ""){errors.glcode = "Missing GL Code";invalidData.general++}
                      
                      // Validate reporting type matches
                      if (this.SelectedReportingType && this.glreportingtypemap[currentRowData.glcode] && 
                          this.SelectedReportingType !== this.glreportingtypemap[currentRowData.glcode]) {
                        const glReportingTypeName = this.glreportingtypemap[currentRowData.glcode].toUpperCase() === 'PL' ? 'Profit & Loss' : 'Balance Sheet';
                        const selectedReportingTypeName = this.SelectedReportingType.toUpperCase() === 'PL' ? 'Profit & Loss' : 'Balance Sheet';
                        errors.glcode = `GL Code reporting type (${glReportingTypeName}) does not match selected reporting type (${selectedReportingTypeName})`;
                        invalidData.general++;
                      }
                      
                      if ((key==='glfile' || key==='slfile') && visitedGlCodes[currentRowData.rucode] && visitedGlCodes[currentRowData.rucode].indexOf(currentRowData.glcode+month+year) !== -1) {
                      errors.glcode = "Duplicated GL Code in uploaded data for period " + periodStr;
                      invalidData.general++;
                      }
                      if(typeof currentRowData.glcode !== undefined && (key==='glfile' || key==='slfile')){
                      visitedGlCodes[currentRowData.rucode].push(currentRowData.glcode+month+year);
                      }
                    }
                    // Validate period against fiscal year range
                    let [fyStartyear, fyStartmonth] = this.minDate.split("-");
                    let [fyEndyear, fyEndmonth] = this.maxDate.split("-");
                    const date = new Date(year, parseInt(month) - 1, 1);
                    const fyStartDate = new Date(fyStartyear, fyStartmonth - 1, 1);
                    const fyEndDate = new Date(fyEndyear, fyEndmonth - 1, 1);
                    if(date < fyStartDate || date > fyEndDate){
                      errors.period = "Period is not available";
                      invalidData.general++;
                      this.bulksubmitrufileerrorflag = true;
                      this.bulksubmitglfileerrorflag = true;
                      this.bulksubmitslfileerrorflag = true;
                    }
                    const actualLocal_proforma = varianceAnalysisConstants.MATERIALITY.ACTUAL_LOCAL_PROFORMA;
                    const actualRegional_proforma = varianceAnalysisConstants.MATERIALITY.ACTUAL_REGIONAL_PROFORMA;
                    const actualLocal_forecast = varianceAnalysisConstants.MATERIALITY.ACTUAL_LOCAL_FORECAST;
                    const actualRegional_forecast = varianceAnalysisConstants.MATERIALITY.ACTUAL_REGIONAL_FORECAST;
                    const actualFields = actualLocal_proforma.concat(actualRegional_proforma, actualLocal_forecast, actualRegional_forecast);
                    const forecastLocal_proforma = varianceAnalysisConstants.MATERIALITY.FORECAST_LOCAL_PROFORMA;
                    const forecastRegional_proforma = varianceAnalysisConstants.MATERIALITY.FORECAST_REGIONAL_PROFORMA;
                    const forecastLocal_forecast = varianceAnalysisConstants.MATERIALITY.FORECAST_LOCAL_FORECAST;
                    const forecastRegional_forecast = varianceAnalysisConstants.MATERIALITY.FORECAST_REGIONAL_FORECAST;
                    const forecastFields = forecastLocal_proforma.concat(forecastRegional_proforma, forecastLocal_forecast, forecastRegional_forecast);
                    const ignoredFields = varianceAnalysisConstants.MATERIALITY.IGNORED_FIELDS;
                    const controlPercentValue = varianceAnalysisConstants.DEFAULTS.CONTROL_PERCENT_VALUE;
                    let errorDataType = 'actual_local_error_data';
                    let fields = [];
                    if(!this.bulkCycleType){
                      fields = actualFields;
                      this.bulksubmitrufilecolumns= varianceAnalysisConstants.MATERIALITY.BULK_SUBMIT_RU_FILE_COLUMNS_ACTUAL;
                      this.bulksubmitglfilecolumns= varianceAnalysisConstants.MATERIALITY.BULK_SUBMIT_GL_FILE_COLUMNS_ACTUAL;
                    }else{
                      fields = forecastFields;
                      this.bulksubmitrufilecolumns= varianceAnalysisConstants.MATERIALITY.BULK_SUBMIT_RU_FILE_COLUMNS_FORECAST;
                      this.bulksubmitglfilecolumns= varianceAnalysisConstants.MATERIALITY.BULK_SUBMIT_GL_FILE_COLUMNS_FORECAST;
                    }
                    fields.forEach((field, index) => {
                      if(actualLocal_proforma.indexOf(field) > -1){
                        errorDataType = 'actual_local_proforma_error_data'
                      }
                      else if(actualRegional_proforma.indexOf(field) > -1){
                        errorDataType = 'actual_regional_proforma_error_data'
                      }
                      else if(actualLocal_forecast.indexOf(field) > -1){
                        errorDataType = 'actual_local_forecast_error_data'
                      }
                      else if(actualRegional_forecast.indexOf(field) > -1){
                        errorDataType = 'actual_regional_forecast_error_data'
                      }
                      else if(forecastLocal_proforma.indexOf(field) > -1){
                        errorDataType = 'forecast_local_proforma_error_data'
                      }
                      else if(forecastRegional_proforma.indexOf(field) > -1){
                        errorDataType = 'forecast_regional_proforma_error_data'
                      }
                      else if(forecastLocal_forecast.indexOf(field) > -1){
                        errorDataType = 'forecast_local_forecast_error_data'
                      }
                      else if(forecastRegional_forecast.indexOf(field) > -1){
                        errorDataType = 'forecast_regional_forecast_error_data'
                      }
                      if (typeof el[startindex + index] === 'number' && !isNaN(Number(el[startindex + index]))) {
                      currentRowData[field] = Number(el[startindex + index]);
                      } else {
                        if(ignoredFields.indexOf(field) === -1){
                          invalidData[errorDataType]++;
                          errors[field] = "Missing Values";
                        }
                      }
                    });
                    
                    if (invalidData.actual_local_proforma_error_data === (actualLocal_proforma.length-1) && 
                      invalidData.actual_regional_proforma_error_data === (actualRegional_proforma.length-1) && 
                      invalidData.forecast_local_proforma_error_data === (forecastLocal_proforma.length -1) && 
                      invalidData.forecast_regional_proforma_error_data === (forecastRegional_proforma.length-1) && 
                      invalidData.actual_local_forecast_error_data === (actualLocal_forecast.length ) && 
                      invalidData.actual_regional_forecast_error_data === (actualRegional_forecast.length) && 
                      invalidData.forecast_local_forecast_error_data === (forecastLocal_forecast.length) && 
                      invalidData.forecast_regional_forecast_error_data === (forecastRegional_proforma.length)) {
                      // No data validation errors found
                    } else {
                      if(invalidData.actual_local_proforma_error_data !== actualLocal_proforma.length-1 && invalidData.actual_local_proforma_error_data !==0){
                        actualLocal_proforma.forEach((field)=>{
                            errorFormatData[field] = errors[field] || null;
                        })
                        currentRowData["a_c_l_per_pro"] = controlPercentValue;
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      } else {
                        if(invalidData.actual_local_proforma_error_data !== (actualLocal_proforma.length-1) && !this.bulkCycleType){
                          currentRowData["a_c_l_per_pro"] = controlPercentValue;
                        }
                      }
                      if (invalidData.actual_regional_proforma_error_data !== (actualRegional_proforma.length-1) && invalidData.actual_regional_proforma_error_data !== 0) {
                        actualRegional_proforma.forEach((field) => {
                            errorFormatData[field] = errors[field] || null;
                        })
                        currentRowData["a_c_r_per_pro"] = controlPercentValue;
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      } else {
                        if(invalidData.actual_regional_proforma_error_data !== (actualRegional_proforma.length-1) && !this.bulkCycleType){
                          currentRowData["a_c_r_per_pro"] = controlPercentValue;
                        }
                      }
                      if (invalidData.forecast_local_proforma_error_data !== (forecastLocal_proforma.length-1) && invalidData.forecast_local_proforma_error_data !== 0) {
                        forecastLocal_proforma.forEach((field)=>{
                            errorFormatData[field] = errors[field] || null;
                        })
                        currentRowData["f_c_l_per_pro"] = controlPercentValue;
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      }else {
                        if(invalidData.forecast_local_proforma_error_data !== (forecastLocal_proforma.length-1) && this.bulkCycleType){
                          currentRowData["f_c_l_per_pro"] = controlPercentValue;
                        }
                      }
                      if (invalidData.forecast_regional_proforma_error_data !== (forecastRegional_proforma.length-1) && invalidData.forecast_regional_proforma_error_data !== 0) {
                        forecastRegional_proforma.forEach((field) => {
                            errorFormatData[field] = errors[field] || null;
                        })
                        currentRowData["f_c_r_per_pro"] = controlPercentValue;
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      }else {
                        if(invalidData.forecast_regional_proforma_error_data !== (forecastRegional_proforma.length-1) && this.bulkCycleType){
                          currentRowData["f_c_r_per_pro"] = controlPercentValue;
                        }
                      }
                      if(invalidData.actual_local_forecast_error_data !== actualLocal_forecast.length && invalidData.actual_local_forecast_error_data !== 0){
                        actualLocal_forecast.forEach((field)=>{
                            errorFormatData[field] = errors[field] || null;
                        })
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      } 
                      if (invalidData.actual_regional_forecast_error_data !== (actualRegional_forecast.length) && invalidData.actual_regional_forecast_error_data !== 0) {
                        actualRegional_forecast.forEach((field) => {
                          errorFormatData[field] = errors[field] || null;
                        })
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      } 
                      if (invalidData.forecast_local_forecast_error_data !== (forecastLocal_forecast.length) && invalidData.forecast_local_forecast_error_data !== 0) {
                        forecastLocal_forecast.forEach((field)=>{
                          errorFormatData[field] = errors[field] || null;
                        })
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      }
                      if (invalidData.forecast_regional_forecast_error_data !== (forecastRegional_forecast.length) && invalidData.forecast_regional_forecast_error_data !== 0) {
                        forecastRegional_forecast.forEach((field) => {
                            errorFormatData[field] = errors[field] || null;
                        })
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      } 
                    }
                    processedRows.push(currentRowData);
                    }
                  }
                  // Add error data for the general row
                      if(invalidData.general !== 0){
                        errorFormatData.rucode = errors.rucode || null; 
                        errorFormatData.glcode = errors.glcode || null; 
                        errorFormatData.month = errors.month || null;
                        errorFormatData.year = errors.year || null;
                        errorFormatData.period = errors.period || null; 
                        this.bulksubmitrufileerrorflag = true;
                        this.bulksubmitglfileerrorflag = true;
                        this.bulksubmitslfileerrorflag = true;
                      }                      
                  // Add all processed rows to filedata and corresponding error entries
                  for (let processedRow of processedRows) {
                    filedata.push(processedRow);
                    errordata.push({...errorFormatData});
                    }
                  }
                }
              }
              
              // Validate empty data
              if(filedata.length === 0) {
                this.$store.commit('sbError', "No valid data found in the uploaded file");
                this.bulksubmitrufileerrorflag = true;
                this.bulksubmitglfileerrorflag = true;
                this.bulksubmitslfileerrorflag = true;
              }
              
              if(key === "rufile") {
                this.bulksubmitrufiledata = filedata;
                this.bulksubmitrufileerror = errordata;
                if(filedata.length === 0) {
                  this.bulksubmitrufileerrorflag = true;
                } else if(this.bulksubmitrufileerrorflag){
                  this.$store.commit('sbError',"There are few values missing")
                }
              }
              else if(key === "glfile") {
                this.bulksubmitglfiledata = filedata;
                this.bulksubmitglfileerror = errordata;
                if(filedata.length === 0) {
                  this.bulksubmitglfileerrorflag = true;
                } else if (this.bulksubmitglfileerrorflag) {
                  this.$store.commit('sbError', "There are few values missing")
                }
              }
              else if(key === "slfile") {
                this.bulksubmitslfiledata = filedata;
                this.bulksubmitslfileerror = errordata;
                if(filedata.length === 0) {
                  this.bulksubmitslfileerrorflag = true;
                } else if (this.bulksubmitslfileerrorflag) {
                  this.$store.commit('sbError', "There are few values missing")
                }
              }
            } else throw Error("Columns '"+headings.join("','")+"' are required in the same order");
          }else {
            let cycle = this.bulkCycleType?'Forecast':'Actual'
            throw Error("Please upload "+cycle+" cycle template data");
          }
        }).catch(err => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
        }).finally(() => {
          this.bulksubmitrubkpfile = null;
          this.bulksubmitglbkpfile = null;
          this.bulksubmitslbkpfile = null;
          this.bulksubmitrufile = null;
          this.bulksubmitglfile = null;
          this.bulksubmitslfile = null;
          this.fileprocessing[key] = 0;
          this.bulksubmitruloading = false;
          this.bulksubmitglloading = false;
          this.bulksubmitslloading = false;
        });
      }
    },
    isValidDateFormat(dateString) {
      const mmYyyyRegex = /^(0[1-9]|1[0-2])-(20\d{2})$/; 
      return mmYyyyRegex.test(dateString);
    },
    toISOConverter(rawDate) {
      try {
        const date = new Date(rawDate);

        // Extract date components
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // January is 0
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        // Format the date as desired (e.g., YYYY-MM-DD HH:mm:ss)
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        return formattedDate
      } catch (error) {
        console.error('[Threshold]: toISOConverter error', error.message);
      }

    },
    cancelEditItem(id,type='proforma') {
      const index = this.editablegls[type].indexOf(id);
      if (index === -1) {
        this.editablegls[type].push(id);
      } else {
        this.editablegls[type].splice(index, 1);
        // Get the appropriate threshold keys based on type
        const thresholdKeys = type === 'proforma' 
          ? varianceAnalysisConstants.MATERIALITY.PROFORMA_THRESHOLD_KEYS 
          : varianceAnalysisConstants.MATERIALITY.FORECAST_THRESHOLD_KEYS;
        const defaultThreshold = varianceAnalysisConstants.DEFAULTS.THRESHOLD_VALUE;
        
        // Reset each threshold key to its original value or default
        thresholdKeys.forEach(key => {
          this.addeditgldata[id][key] = this.addeditgldatacopy[id]?.[key] || defaultThreshold;
        });
      }
    },
    removeMonth(month) {
      this.addeditrudata.periods = this.addeditrudata.periods.filter((m) => m !== month);
      delete this.formattedRUData[month.split('-').reverse().join('-')];
    },
    openBulkUploadDialog(initialTab = 0) {
      
      this.bulkUploadInitialTab = initialTab;
      this.bulksubmitrufiledata = [];
      this.bulksubmitglfiledata = [];
      this.bulksubmitslfiledata = [];
      this.bulksubmitrufileerror = [];
      this.bulksubmitglfileerror = [];
      this.bulksubmitslfileerror = [];
      this.bulksubmitrufileerrorflag = false;
      this.bulksubmitglfileerrorflag = false;
      this.bulksubmitslfileerrorflag = false;
      this.emptyRuCode = false;
      this.bulkCycleType = false;
      this.bulkUploadDialog = true;
    },
    handleBulkFileChange({ fileType, file, cycleType, reportingType }) {
      this.bulkCycleType = cycleType;
      if (fileType === 'rufile') {
        this.bulksubmitrufile = file;
        this.SelectedReportingType = reportingType;
        this.readBulkSubmitFile('rufile');
      } else if (fileType === 'glfile') {
        this.bulksubmitglfile = file;
        this.SelectedReportingType = reportingType;
        this.readBulkSubmitFile('glfile');
      } else if (fileType === 'slfile') {
        this.bulksubmitslfile = file;
        this.SelectedReportingType = reportingType;
        this.readBulkSubmitFile('slfile');
      }
    },
    handleCycleTypeChange(cycleType) {
      this.bulkCycleType = cycleType;
      // Clear file data when cycle type changes
      this.bulksubmitrufiledata = [];
      this.bulksubmitglfiledata = [];
      this.bulksubmitslfiledata = [];
      this.bulksubmitrufileerrorflag = false;
      this.bulksubmitglfileerrorflag = false;
      this.bulksubmitslfileerrorflag = false;
    },
    handleBulkUploadProceed({ fileType, cycleType, reporting_type }) {
      this.bulkCycleType = cycleType;
      this.addeditrudata.__type = fileType;
      this.addeditrudata.reporting_type = reporting_type;
      this.cycle = 'Both';
      this.updateThreshold();
    },
    /**
     * Handles column selection change from MaterialityHeader
     * Updates visibleColumns array with selected column values
     * @param {Array} columns - Array of selected column values
     */
    handleColumnsChange(columns) {
      this.visibleColumns = columns;
    },
  },
  computed: {
    ...mapGetters('varianceanalysis/reportingUnit', {
      storeAllReportingUnits: 'getAllReportingUnits',
      storeAllReportingUnitsMeta: 'getAllReportingUnitsMeta',
      storeGLList: 'getGLList',
      storeGLCodeNameMap: 'getGLCodeNameMap',
      storeGLCodeIdMap: 'getGLCodeIdMap',
      storeGLReportingTypeMap: 'getGLReportingTypeMap',
      storeAllGLs: 'getAllGLs',
      storePendingApprovalRequests: 'getPendingApprovalRequests',
      storeMyMaterialityData: 'getMyMaterialityData'
    }),
     meta() {
        return this.dataMeta || { count: 0 };
    },
    slfilterData(){
      return this.formattedGLData.filter(item => item.sub_ledger_exists === true);
    },
    isWPPClient() {
      return this.$nova.labelsName('materiality_page','unit_label','reporting unit') === 'reporting unit';
    },
    /**
     * Returns headers with modified lock property based on column visibility selection
     * - Columns with lock: true or undefined are always visible
     * - Unlocked columns (lock: false) get lock: true if selected in visibleColumns
     * - Unselected unlocked columns are excluded from the array
     * @returns {Array} Array of header objects with adjusted lock values
     */
    filteredHeaders() {
      // Build filterList maps for server-side filtered columns
      // so DataTableNew shows all known values (not just current page)
      const filterListMap = {
        code: this.ruCodeFilterList,
        network: Object.keys(this.networkNameIdMap).map(name => ({ name, value: name })),
        region: Object.keys(this.regionNameIdMap).map(name => ({ name, value: name })),
        country: Object.keys(this.countryNameIdMap).map(name => ({ name, value: name })),
      };

      return this.headers
        .filter((header) => {
          // Always include locked columns or columns without lock property
          if (header.lock === true || header.lock === undefined) {
            return true;
          }
          // Include unlocked columns only if selected
          return this.visibleColumns.includes(header.value);
        })
        .map((header) => {
          const mapped = { ...header };
          // For unlocked columns that are selected, set lock to true so DataTableNew shows them
          if (header.lock === false && this.visibleColumns.includes(header.value)) {
            mapped.lock = true;
          }
          // Inject filterList for server-side filtered columns
          if (filterListMap[header.value] && filterListMap[header.value].length > 0) {
            mapped.filterList = filterListMap[header.value];
          }
          return mapped;
        });
    }
  },
  watch: {
    'addeditrudata.periods': {
      async handler(newVal=[]) {
        const thresholdKeys = varianceAnalysisConstants.MATERIALITY.THRESHOLD_KEYS;
        const defaultThreshold = varianceAnalysisConstants.DEFAULTS.THRESHOLD_VALUE;
        const controlPercentValue = varianceAnalysisConstants.DEFAULTS.CONTROL_PERCENT_VALUE;
          
          newVal.forEach(period=>{
            let formatPeriod = period.split('-').reverse().join('-');
            if(typeof this.formattedRUData[formatPeriod] !== 'undefined'){
              this.formattedRUData[formatPeriod] = this.formattedRUData?.[formatPeriod] || {};
            }
            else{
              this.formattedRUData[formatPeriod] = {};
              this.formattedRUErrorData[formatPeriod] = {};
              thresholdKeys.forEach(key => {
                  this.formattedRUData[formatPeriod][key] = defaultThreshold;
              });
              this.formattedRUData[formatPeriod]['control_thresholds_percent_proforma'] = controlPercentValue;
              this.formattedRUData[formatPeriod]['control_thresholds_percent_regional_proforma'] = controlPercentValue;
            }
          })
          Object.entries(this.formattedRUData).forEach(([key]) => {
            if(!newVal.includes(key.split('-').reverse().join('-'))){
              delete this.formattedRUData[key.split('-').reverse().join('-')];
              delete this.formattedRUErrorData[key.split('-').reverse().join('-')];
            }
          });
      },
      deep: true
    },
    singleupdatetype:{
      handler(newVal){
        if(newVal === true){
          this.multipleMaterialityToggle=false
        }
      }
    },
    bulkCycleType() {
      this.bulksubmitglfiledata = [];
      this.bulksubmitrufiledata = [];
      this.bulksubmitglfileerrorflag= false;
      this.bulksubmitrufileerrorflag= false;
    },
  }
}
</script>

<style type="scss" scoped>
.commentary_materiality_actual{
  font-color: #7A9D54
}
.selected-months {
  margin-top: 20px;
}
.selected-months ul {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap to the next line */
  padding: 0;
  margin: 0;
  list-style-type: none; /* Remove default list styling */
}
.month-item {
  display: flex;
  align-items: center;
  margin: 1px 2px; /* Spacing around items */
  padding: 0px 2px;
  background-color: #e0f7fa; /* Background color for items */
  border-radius: 5px;
  font-size: 0.7em;
}
.custom-tooltip.tooltip-bottom::before{
      
  left:70% !important;               
  /* Additional customizations here */
}
/* RU-GL-SL styles */
.wisetab{
  border-bottom: 1px solid #E5E5E5;
  border-radius: 0;
}
.wisetab .v-tab {
  padding: 0 12px;
  min-width: auto;
}
.wisetab::v-deep .v-tabs-bar {
    height: 34px;
}
.rutablelabel{
  color: #828285;
  margin-bottom: 5px;
}
.selectmonth{
  color: #828285;
}
</style>

